document.addEventListener("DOMContentLoaded", () => {
  const finalStates = () => {
    const mainBanner = document.querySelector(".banner-slider-wrapper");
    mainBanner.classList.add('second-time');
    mainBanner.classList.remove('first-time');
    gsap.set(".hero-banner__grid-item-animate", { opacity: 0, scale: 1 });
    gsap.set(".hero-banner__main-image-animate", { 
      opacity: 1,
      scale: 1,
      width: window.innerWidth + "px",
      height: window.innerWidth > 767
        ? window.innerHeight + "px"
        : window.innerHeight + 150 + "px"
    });
    gsap.set(".hero-banner__logo-animate", { display: "none", opacity: 0 });
    gsap.set(".header-wrapper", { opacity: 1 });
    gsap.set(".banner-button-animate", { opacity: 1 });
    document.body.classList.remove('no-scroll');
  };

  if (sessionStorage.getItem("homepageAnimationDone")) {
    finalStates();
    return;
  }

  document.body.classList.add('no-scroll');
  const paths = document.querySelectorAll(".path-animate");
  paths.forEach((path, i) => {
    setTimeout(() => {
      path.classList.add("show");
    }, i * 100); 
  });
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: "power2.out" }
  });

  tl.fromTo(".hero-banner__grid-item-animate",
    { opacity: 0, scale: 0.9 },
    { opacity: 1, scale: 1, ease: "back.out(4)", stagger: 0.1 },
    "<1"
  );

  tl.fromTo(".hero-banner__main-image-animate",
    { opacity: 0, scale: 0.9 },
    { opacity: 1, scale: 1, ease: "back.out(4)", duration: 0.1 },
    "<0.5"
  );

  let img = document.querySelector(".hero-banner__main-image-animate");
  let rect = img.getBoundingClientRect();

  tl.fromTo(img,
    { width: rect.width + "px", height: rect.height + "px" },
    {
      width: window.innerWidth + "px",
      height: window.innerWidth > 767
        ? window.innerHeight + "px"
        : window.innerHeight + 150 + "px",
      ease: "power2.out",
      duration: 1
    }
  );

  tl.to(".hero-banner__logo-animate", {
    top: "40px",
    maxWidth: window.innerWidth > 767 ? "230px" : "188px",
    duration: 1
  }, "<0.4");

  tl.addLabel("logoMoved");

  tl.to(".header-wrapper", { opacity: 1 }, "logoMoved+=0.1");
  tl.to(".hero-banner__logo-animate", { opacity: 0, duration: 0.5 }, "logoMoved+=0.1");
  tl.set(".hero-banner__logo-animate", { display: "none" });
  tl.to(".banner-button-animate", { opacity: 1, duration: 0.3, ease: "linear" }, "logoMoved+=0.1");

  tl.add(() => {
    document.body.classList.remove('no-scroll');
    sessionStorage.setItem("homepageAnimationDone", "true");
  });
});
